module.exports = __webpack_public_path__ + "img/creditserver.1d41a0b9.png";